import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty, size, sumBy, sum } from 'lodash';
import {  Grid, Box, TableFooter, Button, IconButton, Typography, Paper, Link } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import Currency from '../../../../commonModules/Currency';
import { AddCircleOutlineRounded, CloudDownloadRounded, DeleteRounded } from '@material-ui/icons';
import  mime  from 'mime';

import PopUp from '../../../../commonModules/interface/PopUp';
import { fetchSaleCredits } from '../../../../../../../jsx/actions/saleCreditsAction';
import { fetchShops } from '../../../../../../../jsx/actions/shopAction';
import { addFilesPurchase, addFacturesPurchase, deleteFilePurchase, linkPurchasesTo5000, unLinkPurchasesTo5000 } from '../../../../../../../jsx/actions/purchaseAction';
import { getIncomeInfo } from '../../../../../../../jsx/actions/paymentAction';

import Axios from 'axios';
import FactureComptaPopUp from '../purchases/FactureComptaPopUp';
import InputFactID from '../purchases/InputFactID';
import { Files } from '../../../../commonModules/interface/input-files';
import DeleteDialog from '../../../../commonModules/interface/DeleteDialog';
import LinkPurchasePopUp from '../transfers/purchases/LinkPurchasePopUp';
import { toast } from 'react-toastify';
import { SingleSwitch } from '../../../../commonModules/MUI/RadioAndCheckbox';

const FILENAMES = [
    "reappro_files",
    "purchase_files",
    "purchase_files_BL",
    "purchase_files_BESC",
    "purchase_files_fact",
    
]
// ADD     const addFilesPurchase = dispatch( addFilesPurchase());

class SingleTemplate extends Component {
    state = {
        src: "",
        newFiles: [],
        addFiles: false,
        deleteFileTarget: null,
        factExist: {},
        factList: "",
        spendingID: "",
        fact_id_5000: this.props.sale.fact_id_5000 || "",
        checkedPayments: [this.props.sale.id],
        errors:{
            fact_id_5000: "",
        }
    }
    componentDidMount = () => {
        console.log("[INFO] MOUNTING SINGLE ");
        const { sale } = this.props

        FILENAMES.map( fieldname => {
            if( !isEmpty(sale[fieldname]) ) {
                sale[fieldname].map( file => {
                    console.log('====================================');
                    console.log({file});
                    console.log('====================================');
                    this.downloadFile(file.filename)
                })
            }

        })
        
        if ( sale.sale_credit && isEmpty(this.props.SALE_CREDITS) ){
            this.props.fetchSaleCredits()
        }
        if ( isEmpty(this.props.SHOPS) ){
            this.props.fetchShops()
        }
        if ( !isEmpty(sale.fact_id_5000) ){
            let factList = sale.fact_id_5000
            if (sale.fact_id_5000.startsWith(", ")){
                factList = sale.fact_id_5000.substring(2)
            }
            this.setState({factList})
            this.checkFactID(factList)
        }
    }
    componentDidUpdate = (prevProps) => {
        const { sale } = this.props;
        if (prevProps.sale.purchase_files !== sale.purchase_files && !isEmpty(sale.purchase_files)) {
            sale.purchase_files.forEach( file => {
                if (this.state[file.filename] === undefined) {
                    this.downloadFile(file.filename)
                }
            })
        }
    }

    filterList = () => {
        const { SALE_CREDITS } = this.props;
        let list = !isEmpty(SALE_CREDITS) ? Object.values(SALE_CREDITS).filter( item => item.sale_id === this.props.sale.id) : []
        return list
    }
    downloadFile = async (path) => {
        try {
            const req = await fetch('/stocks/getPhotos', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({ path: path }),
                credentials: 'same-origin'
            });
            const src = await req.json();
            console.log(src);
            if (src.error) {
                console.log("[ERROR], fetching file ", src)
                return;
            }
            this.setState({
                [path]: src.uri,
            });
        } catch (err) {
            console.log("[ERROR], catch fetching file", err)
        }
    }
    handleSubmit = async () => {
        let data = {
            purchase_files: this.state.newFiles,
            id: this.props.sale.id
        }
        await this.props.addFilesPurchase(data)
        if(this.props.STATE_PURCHASE.error){
            console.log("ERROR", this.props.STATE_PURCHASE.error);

            toast.error( this.props.STATE_PURCHASE.error)
        } else{
            console.log("fetched");
            //success

            toast.info( "L'opération a été modifiée avec succès")
            this.setState({
                addFiles: false,
                newFiles: []
            })
        }
    }
    handleDeleteFile = async (password) => {
        const { deleteFileTarget } = this.state;
        if (!deleteFileTarget) return;

        await this.props.deleteFilePurchase({
            id: this.props.sale.id,
            password,
            filename: deleteFileTarget.filename
        })
        if(this.props.STATE_PURCHASE.error){
            console.log("ERROR", this.props.STATE_PURCHASE.error);

            toast.error( this.props.STATE_PURCHASE.error)
        } else{
            toast.info( "Le fichier a été supprimé avec succès")
            this.setState({ deleteFileTarget: null })
        }
    }
    // handleSubmitFact = async () => {
    //     let data = {
    //         fact_id_5000: this.state.fact_id_5000,
    //         id: this.props.sale.id
    //     }
    //     if (this.props.sale.type === "purchase"){
    //         await this.props.addFacturesPurchase(data)
    //         if(this.props.STATE_PURCHASE.error){
    //             console.log("ERROR", this.props.STATE_PURCHASE.error);
                
    //             this.props.notif( "danger", this.props.STATE_PURCHASE.error)
    //         } else{
    //             console.log("fetched");
    //             //success 
                
    //             this.props.notif( "info", "L'achat a été modifié avec succès")
    //             this.setState({
    //                 addFactures: false,
    //                 fact_id_5000: this.props.sale.fact_id_5000
    //             })
    //         }
    //     } 
    // }

	rmPayment = (payID) => {
		let cpParts = Object.assign({}, this.state.parts)
		let newList = [].concat(this.state.checkedPayments)
		newList = newList.filter(id => id !== payID)
        delete cpParts[payID]

        console.log('====================================');
        console.log({cpParts});
        console.log('====================================');
		this.setState({
            checkedPayments : newList,
            parts: cpParts,
			totalPay: this.calcTotalV2(newList)
        });
	}

    handleChangeParts = (parts) => {
        this.setState({
            parts,
			totalPay: sum(Object.values(parts))            
        });
    }
    handleSubmitLink = async () => {
		let data = {
			spending_id : this.state.spendingID,
			id_list: this.state.parts, 
			total: this.calcTotalV2(this.state.checkedPayments)
		}
		await this.props.linkPurchasesTo5000(data)
		if(this.props.STATE.purchases.error){ // STATE.purchases
			console.log("ERROR", this.props.STATE.purchases.error)				
			toast.error( this.props.STATE.purchases.error)
		} else {
			toast.info("Opération enregistrée avec succès")
			// this.handleSelectAllClick()                        	
		}
	}
	handleSubmitUnLink = async () => {
		let data = {
			spending_id : this.state.unlink.fact_id_5000,
			id_list: [this.state.unlink.id], 
			total: this.state.unlink.total_price
		}
		await this.props.unLinkPurchasesTo5000(data)
		if(this.props.STATE.purchases.error){
			console.log("ERROR", this.props.STATE.purchases.error)				
			toast.error(  this.props.STATE.purchases.error)
		} else {
			toast.info("Opération enregistrée avec succès")
            this.setState({addFactures: false})
			// this.handleSelectAllClick()                        	
		}
	}
	
	calcTotal = (list) => {
		const { PURCHASES } = this.props;
		// let totalPay = 0
		
        console.log('====================================');
        console.log({list});
        console.log('====================================');
		// list.forEach(pay => totalPay += PURCHASES[pay].total_price)
		// return totalPay
		// return sumBy(list, (purchaseID) => (PURCHASES[purchaseID].total_price))
		return sumBy(list, (purchaseID) => (PURCHASES[purchaseID].purchase_total_available))
	} 
	calcTotalV2 = (list) => {
        const { parts } = this.state;
		
        console.log('====================================');
        console.log({list});
        console.log('====================================');
	
		return sumBy(list, (purchaseID) => (parts[purchaseID]))
	} 
    checkFactID = (fact_id_5000) => {
        const { sale } = this.props;
        let factExist = {}
        let factList = fact_id_5000
        let partDetails = {}
        let config = {
            headers: {
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
            }
        }
        
        if( sale.type === "purchase"){
            factList.split(", ").forEach( async (itemID, i) => {
                if (i === 0) {
                    const res1 = await Axios.post("/stocks/addData", {page:"purchases/match/part/list", data: sale.id}, config)
                    console.log({res1});
        
                    if (res1.data ){
                        res1.data.forEach(item => partDetails[item.spending_id] = item)
                    }
                }
                if (itemID ) {
                    if (!factExist[itemID]) {
                        
                        const res = await Axios.post("/stocks/compta/spendings/single", {spendingID: itemID}, config)
                        console.log({res});
                        if (res.data && res.data.spending_id != "") {
                            res.type = "spending"
                            factExist[itemID] = res.data
                        }
                    }
                }
            })
        } else {
            factList.split(", ").forEach( async itemID => {
                if (itemID ) {
                    if (!factExist[itemID]) {
                        const res = await this.props.getIncomeInfo(itemID)
                        console.log('====================================');
                        console.log({res});
                        console.log('====================================');
                        if (!res.error && res.income_amount !== 0) {
                            res.type = "income"
                            factExist[itemID] = res
                        }
                    }
                }
            })
        }
        
        this.setState({
            factExist,
            factList,
            partDetails
        })
        
    }

    handleChange = async  (e) => {  
        const field = e.target.name
        const value = e.target.value
        
        this.setState({
            [field]: value.trim()
        })
    }
    render() {
        console.log("[PROPS] SingleTemplate",this.props);
        console.log("[STATE] SingleTemplate",this.state);
        
        const { addFiles, spendingID, spending_id, factExist, addFactures, partDetails } = this.state;
        const { client, shopDest, sale, agent, commercial, purchase, shopID, SHOPS, TVAOpt } = this.props;
        let shop = this.props.shop
        if (shopID && !isEmpty(SHOPS)) {
            shop = SHOPS[shopID]
        }
        
        let list = []
        let total_payed = 0
        let rest = 0

        console.log('====================================');
        console.log(this.state.factList, );
        console.log( this.state.factList.split(", "));
        console.log( Object.keys(factExist));
        console.log('====================================');

        if(sale.sale_credit) {
            list = this.filterList()
            list.forEach(item => total_payed += item.amount)
            console.log({list});
            rest = sale.total_price - total_payed
        }      
        return(
            <Paper elevation={0}>
                {addFiles &&
                    <PopUp
                        close={()=> this.setState({ addFiles: false, newFiles: [] })}
                        submitAction={this.handleSubmit}
                        maxWidth="sm"
                        title="Ajouter des fichiers"
                        disabledSubmit={this.props.STATE_PURCHASE.fetching}
                    >
                        <Box p={1}>
                            <label htmlFor="purchase_files" className="control-label">Documents</label>
                            <Files
                                photoList={(files) => this.setState({ newFiles : files})}
                                photos={[]}
                                max={20}
                                file
                            />
                        </Box>
                    </PopUp>
                }
                {this.state.deleteFileTarget &&
                    <DeleteDialog
                        title={`le fichier`}
                        handleSubmit={this.handleDeleteFile}
                        block={true}
                        disabled={this.props.STATE_PURCHASE.fetching}
                        close={() => this.setState({ deleteFileTarget: null })}
                    />
                }
                {addFactures &&
                    // <PopUp
                    //     close={()=> this.setState({ addFactures: false })}
                    //     submitAction={this.handleSubmitFact}
                    //     maxWidth="sm"
                    //     title="Ajouter des factures"
                    //     disabledSubmit={this.props.STATE_PURCHASE.fetching}
                    // >
                    //     <Box p={1}>
                    //         <InputFactID 
                    //             id="fact_id_5000" 
                    //             handleChange={this.handleChange} 
                    //             fact_id_5000={this.state.fact_id_5000} 
                    //             name="fact_id_5000" 
                    //             error={this.state.errors.fact_id_5000}
                    //             type={sale.type}
                    //         />
                    //     </Box>
                    // </PopUp>
                    <LinkPurchasePopUp
                        handleClose={()=> this.setState({ addFactures : false, spendingID: "" })}
                        rmPayment={this.rmPayment}
                        handleSubmitLink={this.handleSubmitLink}
                        handleChange={(e) => this.setState({[e.target.name]: e.target.value})}
                        handleChangeParts={this.handleChangeParts}
                        {...this.props}
                        {...this.state}
                    />
                }
                {spending_id && 
                    <FactureComptaPopUp 
                        spendingID={spending_id} 
                        spending={factExist[spending_id]}
                        details={partDetails[spending_id]}
                        handleClose={() => this.setState({ spending_id: ""})}
                    />
                }
                {sale.nature !== "arrivage" ?
                    <Box p={1}>
                        <Alert p={1}>
                            <AlertTitle>Pièces jointes</AlertTitle>
                            {!isEmpty(sale.purchase_files) && sale.purchase_files.map( (file, i) => (
                                <Box key={file.filename} display="inline-block">
                                    <Button
                                        endIcon={<CloudDownloadRounded />}
                                        title="Télécharger"
                                        href={this.state[file.filename]}
                                        download={`${new Date(sale.date).toLocaleDateString('fr-FR')}_${i + 1}_${sale.id.slice(0,8)}.${mime.getExtension(file.filetype)}`}
                                    >
                                        Fichier {i+ 1}
                                    </Button>
                                    <IconButton
                                        size="small"
                                        title="Supprimer"
                                        onClick={() => this.setState({ deleteFileTarget: file })}
                                    >
                                        <DeleteRounded color="error" fontSize="small" />
                                    </IconButton>
                                </Box>
                            )) }
                            {!isEmpty(sale.reappro_files) && sale.reappro_files.map( (file, i) => (
                                <Button
                                    endIcon={<CloudDownloadRounded />}
                                    title="Télécharger"
                                    href={this.state[file.filename]} 
                                    download={`${new Date(sale.date).toLocaleDateString('fr-FR')}_${i + 1}_${sale.id.slice(0,8)}.${mime.getExtension(file.filetype)}`} 
                                >
                                    Fichier {i+ 1}
                                </Button>
                            )) }
                            {isEmpty(sale.purchase_files) && isEmpty(sale.reappro_files) && (
                                <Typography variant="body2" color="textSecondary">
                                    Aucun fichier joint disponible
                                </Typography>
                            )}
                            {sale.type === "purchase" &&
                                <Box>
                                    <Button
                                        startIcon={<AddCircleOutlineRounded /> }
                                        onClick={() => this.setState({ addFiles: true})}
                                        color="primary"
                                        variant="contained"
                                    >
                                        Ajouter
                                    </Button>
                                </Box>
                            }
                        </Alert>
                    </Box>
                    :
                    <Box p={1}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} md={3}>
                                <Alert>
                                    <AlertTitle>Bon Livraison</AlertTitle>
                                    {!isEmpty(sale.purchase_files_BL) && sale.purchase_files_BL.map( (file, i) => (
                                        <Button
                                            startIcon={<CloudDownloadRounded />}
                                            title="Télécharger"
                                            href={this.state[file.filename]} 
                                            download={`BL_${i + 1}_${sale.id.slice(0,8)}.${mime.getExtension(file.filetype)}`} 
                                        >
                                            Fichier {i+ 1}
                                        </Button>
                                    )) }
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Alert>
                                    <AlertTitle>BESC</AlertTitle>
                                    {!isEmpty(sale.purchase_files_BESC) && sale.purchase_files_BESC.map( (file, i) => (
                                        <Button
                                            startIcon={<CloudDownloadRounded />}
                                            title="Télécharger"
                                            href={this.state[file.filename]} 
                                            download={`BESC_${i + 1}_${sale.id.slice(0,8)}.${mime.getExtension(file.filetype)}`} 
                                        >
                                            Fichier {i+ 1}
                                        </Button>
                                    )) }
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Alert>
                                    <AlertTitle>Facture</AlertTitle>
                                    {!isEmpty(sale.purchase_files_fact) && sale.purchase_files_fact.map( (file, i) => (
                                        <Button
                                            startIcon={<CloudDownloadRounded />}
                                            title="Télécharger"
                                            href={this.state[file.filename]} 
                                            download={`Facture_${i + 1}_${sale.id.slice(0,8)}.${mime.getExtension(file.filetype)}`} 
                                        >
                                            Fichier {i+ 1}
                                        </Button>
                                    )) }
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Alert>
                                    <AlertTitle>Autres Documents</AlertTitle>
                                    {!isEmpty(sale.purchase_files) && sale.purchase_files.map( (file, i) => (
                                        <Button
                                            startIcon={<CloudDownloadRounded />}
                                            title="Télécharger"
                                            href={this.state[file.filename]} 
                                            download={`Autres_${i + 1}_${sale.id.slice(0,8)}.${mime.getExtension(file.filetype)}`} 
                                        >
                                            Fichier {i+ 1}
                                        </Button>
                                    )) }
                                </Alert>
                            </Grid>
                        </Grid>
                    </Box>
                }
                {(sale.nature !== "reapprovisionnement" && sale.nature !== "arrivage" && sale.nature !== "demande") &&
                    <Box p={1}>
                        <Alert severity="info" p={1}>
                            <AlertTitle>Factures 5000</AlertTitle>
                            { this.state.factList && this.state.factList.split(", ").map( (spend, i) => (
                            // {!isEmpty(factExist) && this.state.factList.split(", ").map( (spend, i) => (
                                <Button
                                    color="secondary"    
                                    title="Voir"
                                    href="#" 
                                    onClick={()=> this.setState({ spending_id: spend})}
                                >
                                    Facture {i+ 1}
                                </Button>
                            ))}
                            {sale.type === "purchase" &&
                                <Box>
                                    <Button
                                        startIcon={<AddCircleOutlineRounded /> }
                                        onClick={() => this.setState({ addFactures: true})}
                                        color="primary"
                                        variant="contained"
                                    >
                                        Ajouter
                                    </Button>
                                </Box>
                            }
                        </Alert>
                    </Box>
                }
                
                {/* {this.props.localOpt &&
                    <Box p={1} style={{ textAlign: "left"}}>
                        <Button color="primary" variant="outlined" onClick={this.props.handleBL}>Ranger les Articles</Button>
                    </Box>
                }
                 */}
                <Box p={1} style={{ textAlign: "right"}}>
                    {this.props.BLOpt && !this.props.BL &&
                        <Button color="primary" variant="contained" onClick={this.props.handleBL}>Bon de Livraison</Button>
                    }
                    {this.props.BLOpt && this.props.BL &&
                        <Button color="primary" variant="contained" onClick={this.props.handleBL}>Facture</Button>
                    }
                    <Button color="secondary" onClick={() => window.print()}>Imprimer</Button>
                </Box>
                {TVAOpt &&
                    <Box p={2} >
                        <SingleSwitch
                            color="primary"
                            label="Afficher la TVA"
                            labelPlacement="start"
                            name="TVA" 
                            checked={this.props.TVA} 
                            onChange={
                                (e) => this.props.handleCheck(e.target.checked, "TVA")
                            }
                        />
                    </Box>
                }
                
                <div id="section-to-print" style={{padding:"25px 15px 10px"}} >
                    <Box>
                        <Box>
                            {shop &&
                                <Box p={1}>
                                    {shop.logo &&
                                    <Box className="logo">
                                        <img src={`/stocks/photos/${shop.logo.filename}`} alt=""/>
                                    </Box>
                                    }
                                    <Box>
                                        <Typography variant="body1"><b>{shop.name}</b></Typography>
                                        {shop.tel && <Typography variant="body2">{shop.tel} </Typography> }
                                        {shop.email && <Typography variant="body2">{shop.email} </Typography> }
                                        <Typography variant="body2">{shop.address}</Typography>
                                        <Typography variant="body2">{shop.city} - {shop.country}</Typography>
                                    </Box>
                                </Box>
                            }
                            {agent &&
                                <Box p={1}>
                                    <Typography variant="subtitle">Vendu par: </Typography>
                                    <Typography variant="body1">{agent.name}</Typography>
                                    <Typography variant="body2">{agent.phone && agent.phone.join(" - ")} </Typography>                                    
                                    {agent.email && <Typography variant="body2">{agent.email} </Typography>}
                                    <Typography variant="body2">{agent.company}</Typography>
                                </Box>
                            }
                        </Box>

                        <Box m={1} style={{ float: "right", width: "250px"}}>
                            {/* <Grid container spacing={2}>
                                <Grid item sm={6}></Grid>
                                <Grid item sm={6} xs={12} style={{ display: "flex", justifyContent: "flex-end"}}> */}
                                {/* <Grid item sm={4} xs={12} className="text-right pull-right"> */}
                                    {client &&
                                        <Box>
                                            <Typography variant="caption">Client : </Typography>
                                            <Typography variant="body1">{client.client_firstname} {(client.client_lastname).toUpperCase()}</Typography>
                                            <address>
                                                <Typography variant="body2">{client.client_tel}</Typography>
                                                <Typography variant="body2">{client.client_address}</Typography>
                                                <Typography variant="body2">{client.client_city} - {client.client_country}</Typography>
                                            </address>
                                        </Box>
                                    } 
                                    {shopDest &&
                                        <Box >
                                            <Typography variant="caption">Destinataire : </Typography>
                                            <Typography variant="body1">{shopDest.name}</Typography>
                                            <address>
                                                <Typography variant="body2">{shopDest.address}</Typography>
                                                <Typography variant="body2">{shopDest.city}</Typography>
                                                <Typography variant="body2">{shopDest.country}</Typography>
                                            </address>
                                        </Box>
                                    } 
                                    {commercial &&
                                        <Box >
                                            <Typography variant="caption">Commercial : </Typography>
                                            <address>
                                                <Typography variant="body1">{commercial.name}</Typography>
                                                <Typography variant="body2">{commercial.phone && commercial.phone.join(" - ")}</Typography>
                                                <Typography variant="body2">{commercial.email}</Typography>
                                            </address>
                                        </Box>
                                    }
                                {/* </Grid>
                            </Grid> */}
                        </Box>
                        <div style={{clear: "both"}}></div>
                        {sale.type === "resa" &&
                            <Box>
                                <Typography variant="subtitle">Réservation n° {sale.id}</Typography><br />
                                <Typography variant="subtitle">
                                    Date d'utilisation prévue : {(new Date(sale.usage_date)).toLocaleDateString('fr-FR')}
                                </Typography>
                                <hr/>
                                <Alert severity="info">
                                    {sale.comments}
                                </Alert>
                                <hr/>
                            </Box>
                        }
                        {sale.type === "install" &&
                            <Box>
                                <Typography variant="subtitle">Installation n° {sale.id}</Typography><br />
                                <Typography variant="subtitle">
                                    Date d'installation prévue : {(new Date(sale.usage_date)).toLocaleDateString('fr-FR')}
                                </Typography>
                                <hr/>
                                <Alert severity="info">
                                    {sale.comments}
                                </Alert>
                                <hr/>
                            </Box>
                        }
                        {(sale.type !== "install" && sale.type !== "resa") &&
                            <Box>
                                {sale.nature === "achat" &&
                                    <Box p={1} style={{textAlign: 'right'}}><Typography variant="h6"><b>Achat {sale.is_imported ? "Externe" : "Interne"}</b></Typography></Box>
                                }
                                {sale.nature === "reapprovisionnement_ext" &&
                                    <Box p={1} style={{textAlign: 'right'}}><Typography variant="h6"><b>Reappro Externe</b></Typography></Box>
                                }
                                {(sale.nature === "demande" || sale.nature === "arrivage") &&
                                    <Box p={2} style={{textAlign: 'right'}}>
                                        <Typography variant="h6"><b>{sale.nature.toUpperCase()}</b></Typography>
                                        <b>{sale.user_name}</b>
                                    </Box>
                                }
                                <Box p={1}>
                                    {this.props.BL ?
                                        <Typography variant="subtitle"><b>Bon de Livraison  n° {sale.id}</b></Typography>
                                        :
                                        <Typography variant="subtitle"><b>{(sale.nature !== "devis" ? "Facture" : "Devis")} n° {sale.id}</b></Typography>
                                    }
                                    <br />
                                    <Typography variant="button">
                                        Date :  {(new Date(sale.date)).toLocaleString('fr-FR')}
                                    </Typography>
                                    <br />
                                    {(sale.nature === "demande" || sale.nature === "arrivage") &&
                                    <Typography variant="body1" color="secondary">
                                        <b>Date d'arrivée {sale.nature === "arrivage"? "prévue" : "souhaitée"} :  {(new Date(sale.arrival_date)).toLocaleDateString('fr-FR')}</b>
                                    </Typography>
                                }
                                </Box>
                                <br/>
                                {sale.comments &&
                                    <Alert color="warning" severity="info">
                                        <AlertTitle>{sale.comments}</AlertTitle>
                                        {/* <Typography>Reste à payer: {<Currency value={rest} />}</Typography> */}
                                    </Alert>
                                }
                                {sale.sale_credit &&
                                    <Alert severity="info">
                                        <AlertTitle>{sale.comments}</AlertTitle>
                                        <Typography>Reste à payer: {<Currency value={rest} />}</Typography>
                                    </Alert>
                                }
                                <br/>
                            </Box>
                        }
                        <Box style={{ border: "1px dashed lightgray"}}>
                            <Box m={1} p={1} style={{ minHeight: "450px"}}>
                                {this.props.children}
                            </Box>
                        </Box>
                    </Box>
                    {shop && !purchase &&
                        <SingleFooterTemplate shop={shop}/>
                    }
                </div>
            </Paper>
        )
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        SALE_CREDITS: state.inventory.credits,
        STATE_PURCHASE: state.inventory.requestState.purchases,
        STATE_SALE: state.inventory.requestState.sales,
        SHOPS: state.inventory.shops
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        fetchSaleCredits,
        addFilesPurchase,
        addFacturesPurchase,
        deleteFilePurchase,
        fetchShops,
        getIncomeInfo,
        linkPurchasesTo5000,
        unLinkPurchasesTo5000,
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(SingleTemplate);

export class SingleFooterTemplate extends Component {
    state = {  }
    render() {
        const { shop } = this.props;
        return (
            <Box p={1} className="footer text-center">
                <Box><Typography variant="caption" className="bottom-info">{shop.bottom_info}</Typography></Box>
                <Box><Typography variant="caption" className="bottom-info">{shop.bottom_info2}</Typography></Box>
                <Box><Typography variant="caption" className="bottom-info">{shop.bottom_info3}</Typography></Box>
            </Box>
        );
    }
}
